module.exports = "query IssuesAssignedToMeCountQuery{myUser:me{id issues:issuesAssignedTo(closedAt_Isnull:true){totalCount hasUnreadMessages}}}"